import PropTypes from 'prop-types';

import { Box } from '@hivebrite/design-system/Box';
import { ClampedLinkWorkaround } from '@hivebrite/design-system/Dotdotdot';
import { FakeLink } from '@hivebrite/design-system/Link';
import { Slider } from '@hivebrite/design-system/Slider';

import { GroupThumbnail } from 'hb-react/frontoffice/components/GroupThumbnail';
import GroupLoadingCard from 'hb-react/frontoffice/components/GroupThumbnail/GroupLoadingCard';
import useOutboxedFontTheme from 'hb-react/shared/hooks/theme/useOutboxedFontTheme';
import { usePageMenuName, PAGES } from 'hb-react/shared/hooks/usePageMenuName';
import onEnterOrSpacePress from 'hb-react/shared/utils/onEnterOrSpacePress';
import ThemeProvider from 'hb-react/style/ThemeProvider';

import { CARDS_PER_ROW } from './constants';
import useSuggestedGroups from './useSuggestedGroups';

const SuggestedGroups = ({ isInFeed = false, onLoadedEmpty }) => {
  const outboxedFontTheme = useOutboxedFontTheme();

  const { isLoaded, onLoadMore, onSeeAll, topics, totalTopics } =
    useSuggestedGroups();

  const groupsTabName = usePageMenuName(PAGES.TOPICS, __('groups'));

  if (isLoaded && totalTopics === 0) {
    if (isInFeed && onLoadedEmpty) {
      onLoadedEmpty();
    }

    return null;
  }

  const title = s__(
    'LiveFeedSuggestedGroups|Suggested %{groupsTabName} for you',
  ).i__({ groupsTabName });

  return (
    <Box flexDirection="column" mt={6}>
      <Box
        flexDirection="column"
        pl={
          isInFeed
            ? { _: 0 }
            : {
                _: 4,
                m: 0,
                l: -1,
                xl: 0,
              }
        }
        pr={{
          _: 4,
          m: 0,
        }}
        mb={4}
        data-testid="live-feed-suggested-groups"
      >
        <ThemeProvider
          theme="fo"
          fontBrightness={outboxedFontTheme.fontBrightness}
        >
          <Box mt={6} mb={4}>
            <ClampedLinkWorkaround clamp={1} tagName="h2">
              <Box font="h2-semibold" as="span" display="inline">
                {title}
                <span>&nbsp;·&nbsp;</span>
              </Box>
            </ClampedLinkWorkaround>
            <FakeLink
              font="h2-semibold"
              as="span"
              display="inline"
              onClick={onSeeAll}
              onKeyPress={onEnterOrSpacePress(onSeeAll)}
            >
              {s__('LiveFeedSuggestedGroups|See all')}
            </FakeLink>
          </Box>
        </ThemeProvider>
        <Slider
          items={topics}
          total={topics.length}
          perPageBreakpoints={CARDS_PER_ROW}
          ItemComponent={GroupThumbnail}
          LoadingItemComponent={GroupLoadingCard}
          onLoadMore={onLoadMore}
        />
      </Box>
    </Box>
  );
};

SuggestedGroups.propTypes = {
  isInFeed: PropTypes.bool,
  onLoadedEmpty: PropTypes.func,
};

export default SuggestedGroups;
